import { ITipo_Campo } from "../../../helpers/IFormHelper";

export const updateSelectedField = (id: string, valor: any) => { // NOSONAR Dejamos justificado que estas validaciones corresponden a validacion de campos de los formularios dinamicos, que son necesarios para renderear los mantenedores
  let selectedField: any = {};
  if (id) {
    if (typeof valor === "string" || typeof valor === "boolean") {
      selectedField[id] = valor;
    } else if (valor.length > 1) {
      valor.forEach((item: any, index: number) => {
        let mail = item.mail;
        let name = item.name;
        name = name.replace(` (${mail})`, "");
        if (index === 0) {
          selectedField[id] = valor.length === index + 1 ? mail : mail + "; ";
          selectedField[`${id}_DISPLAY`] = valor.length === index + 1 ? name : name + "; ";
        } else {
          selectedField[id] += valor.length === index + 1 ? mail : mail + "; ";
          selectedField[`${id}_DISPLAY`] += valor.length === index + 1 ? name : name + "; ";
        }
        selectedField[`ID`] = id;
        selectedField[`TIPO`] = ITipo_Campo.multiuser;
      });
    } else {
      let mail = valor[0].mail;
      selectedField[id] = valor[0].mail;
      let name = valor[0].name;
      name = name.replace(` (${mail})`, "");
      selectedField[`${id}_DISPLAY`] = name;
      selectedField[`ID`] = id;
      selectedField[`TIPO`] = ITipo_Campo.user;
    }
  }
  return selectedField;
};
export const updateFilter = (filter: any, size: number, page: boolean = false) => {
  if (!filter) {
    filter = {};
  }

  filter.TIPO_FACTOR = filter.ID_TIPO_FACTOR?.toString() || "";
  filter.PAGINADO = size;
  if (filter.PAGINA === undefined) {
    filter.PAGINA = 1;
  }
  if (!page) {
    filter.PAGINA = 1;
  }
  if (filter.ORDENADOPOR === undefined) {
    filter.ORDENADOPOR = "ID";
    filter.ORIENTACION = "DESC";
  }
  return filter;
};
